"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authSuiteLocalStorageService = exports.AuthSuiteLocalStorageService = void 0;
var auth_suite_local_storage_service_1 = require("./auth-suite-local-storage-service");
Object.defineProperty(exports, "AuthSuiteLocalStorageService", { enumerable: true, get: function () { return auth_suite_local_storage_service_1.AuthSuiteLocalStorageService; } });
Object.defineProperty(exports, "authSuiteLocalStorageService", { enumerable: true, get: function () { return auth_suite_local_storage_service_1.authSuiteLocalStorageService; } });
